import { OpenAPI } from '../services';
import { OpenAPI as ScraperOpenApi } from '../services/scraper';
import { OpenAPI as CompressorOpenApi } from '../services/compressor';
import { OpenAPI as AgentCallOpenAPI } from '../services/call-management';
import { OpenAPI as WidgetAnalyticsApi } from '../services/widget-analytics';
import { OpenAPI as ConversationsBilling } from '../services/conversations-billing';
import { OpenAPI as KnowledgeManagement } from '../services/knowledge-base';
import { OpenAPI as ConversationParticipants } from '../services/conversation-participants';
import { OpenAPI as ShortLink } from '../services/short-link';
import { OpenAPI as AccessManagement } from '../services/access-management';
import { OpenAPI as AgentsManagement } from '../services/agents-management';
import { OpenAPI as PromptLibrary } from '../services/prompt-library';
import { OpenAPI as VaultAuthSecret } from '../services/vault-auth';
import { OpenAPI as PresentationsManagement } from '../services/presentations-management';
import { OpenAPI as UrlShortener } from '../services/url-shortener';

export { getCurrentOrg } from './getCurrentOrg';

export * from './agent';
export * from './convo';
export * from './intents';
export * from './management';
export * from './scraping';
export * from './text-compressor';
export * from './form-controller';
export * from './management-settings';
export * from './call-management';
export * from './widget-analytics';
export * from './billing';
export * from './knowledge-management';
export * from './telephony';
export * from './short-link';
export * from './batch-calls';
export * from './prompt-library';
export * from './vault-auth-secret';
export * from './google-connect';
export * from './analytics';
export * from './presentations-management';
export * from './agent-prompts';
export * from './url-shortener';
export * from './sip-providers';
export * from './livekit';

if (process.env.NODE_ENV === 'development') {
  OpenAPI.BASE = '/app/management';
  AgentsManagement.BASE = '/app/management';
  ScraperOpenApi.BASE = '/scraper/api';
  CompressorOpenApi.BASE = '/compressor/api';
  WidgetAnalyticsApi.BASE = '/app/widget';
  ConversationsBilling.BASE = '/app';
  AgentCallOpenAPI.BASE = '/app/management';
  KnowledgeManagement.BASE = '/app';
  ConversationParticipants.BASE = '/app';
  ShortLink.BASE = '/app';
  AccessManagement.BASE = '/app';
  PromptLibrary.BASE = '/app/management';
  VaultAuthSecret.BASE = '/vault';
  PresentationsManagement.BASE = '/app';
  UrlShortener.BASE = '/app' + '/url-shortener/api/v1';
} else {
  OpenAPI.BASE = process.env.REACT_APP_BILLING_BASE_API_URL + '/management';
  AgentsManagement.BASE =
    process.env.REACT_APP_BILLING_BASE_API_URL + '/management';
  AgentCallOpenAPI.BASE =
    process.env.REACT_APP_BILLING_BASE_API_URL + '/management';
  PromptLibrary.BASE =
    process.env.REACT_APP_BILLING_BASE_API_URL + '/management';
  ScraperOpenApi.BASE = process.env.REACT_APP_BASE_API_URL;
  CompressorOpenApi.BASE = process.env.REACT_APP_BASE_API_URL;
  VaultAuthSecret.BASE = process.env.REACT_APP_BASE_API_URL;
  WidgetAnalyticsApi.BASE = process.env.REACT_APP_BASE_API_URL + '/app/widget';
  ShortLink.BASE = process.env.REACT_APP_BILLING_BASE_API_URL;
  ConversationsBilling.BASE = process.env.REACT_APP_BILLING_BASE_API_URL;
  KnowledgeManagement.BASE = process.env.REACT_APP_BILLING_BASE_API_URL;
  ConversationParticipants.BASE = process.env.REACT_APP_BILLING_BASE_API_URL;
  AccessManagement.BASE = process.env.REACT_APP_BILLING_BASE_API_URL;
  PresentationsManagement.BASE = process.env.REACT_APP_BILLING_BASE_API_URL;
  UrlShortener.BASE =
    process.env.REACT_APP_BILLING_BASE_API_URL + '/url-shortener/api/v1';
}

export { OpenAPI, ScraperOpenApi };
